/* eslint-disable react/no-array-index-key */
/* eslint-disable react/no-unused-state */
/* eslint-disable no-mixed-spaces-and-tabs */
import React, { Component } from 'react';
import { isClient } from 'frontend/helpers/ssr-helper';
import moment from 'moment';
import { connect } from 'react-redux';
import ReactTooltip from 'react-tooltip';
import commons from '../../commons/commons';
import ShareWith from './share-with';
import '../paquetes-lista/paquete.css';
import './oferta.css';

const iconoHomologado = {
  vuelo: 'fa fa-plane',
  asistencia: 'fa fa-medkit',
  traslados: 'fa fa-taxi',
  hotel: 'fa fa-bed',
  actividades: 'fa fa-ticket ',
  excursiones: 'fa fa-ticket ',
  guia: 'fa fa-comment',
  bus: 'fa fa-bus',
  barco: 'fa fa-ship',
  tren: 'fa fa-train',
  comidas: 'fa fa-cutlery',
  desayuno: 'fa fa-coffee',
  compras: 'fa fa-shopping-bag',
  'traslados/auto': 'fa fa-car',
  'traslados/autos': 'fa fa-car',
  'documentacion y visados': 'fa fa-id-card-o',
};
class Oferta extends Component {
  constructor(props) {
    super(props);
    this.state = {
      prices: '',
    };
  }

  generarIconosServicios = (listServices) => {
    return listServices.map((servicioId, index) => {
      let icono = iconoHomologado[servicioId];
      if (servicioId.includes('fa-')) icono = `fa ${servicioId}`;
      if (iconoHomologado[servicioId] === false && servicioId.includes('fa-') === false) icono = 'fa fa-tag';
      return (
        <React.Fragment key={index}>
          <span className='icon-container-rounded color-dinamico-fondo'>
            <i className={icono} data-toggle='tooltip' title={servicioId} />
          </span>
        </React.Fragment>
      );
    });
  }

  imgValidator = (imgUrl) => {
    const ImagenDefault = 'https://res.mundigea.com.ar/img/recursos/paquete.jpg';
    if (imgUrl == null || imgUrl === '') return ImagenDefault;

    const TakeFirstUrlImg = imgUrl.split(';');
    const img = TakeFirstUrlImg[0]
      .replace(/\s/g, '%20')
      .replace('https://www.ola.com.ar//www.ola.com.ar', 'https://www.ola.com.ar')
      .replace('travelit/image/upload', 'travelit/image/upload/c_scale,q_50,h_267,w_281,c_fill,q_auto:low');

    return img || ImagenDefault;
  }

  renderStar = (quantity) => {
    if (quantity === 0) return null;

    const stars = [1, 2, 3, 4, 5];
    return (
      <span className='stars-container'>
        {stars.map((currentValue) => {
          const className
                    = currentValue <= quantity
                      ? 'fa fa-star yellow'
                      : 'fa fa-star icon-gray';
          return (
            <div className='inline' key={currentValue}>
              <i className={className} aria-hidden='true' />
            </div>
          );
        })}
      </span>
    );
  }

  render() {
    const { oferta, application } = this.props;

    const Nights = this.props.oferta.nights;
    const titleCleaning = oferta.title.replace(/\([^)]*\)/g, '')
      .replace(/(&amp;)/g, '')
      .replace(/[)]/g, '')
      .replace(/[&]/g, 'and')
      .replace('amp', '')
      .replace(/[;]/g, '')
      .replace(/[<]/g, '')
      .replace(/[>]/g, '')
      .replace('br', '')
      .replace('5A', '')
      .replace('3A', '')
      .replace('6A', '')
      .replace(/[*]/g, '')
      .replace('Feero', 'Febrero')
      .replace('1A', '');

    // Departure Date and Origin
    const DateComplete = moment(this.props.oferta.departureDate, 'YYYY-MM-DD');
    const FormatDate = DateComplete.format('DD/MM/YYYY');
    const OriginComplete = this.props.oferta.origin;
    const OriginOverflow = OriginComplete.length > 14 ? `${OriginComplete.substring(0, 14)}...` : OriginComplete;
    const Origin = OriginComplete.includes('BUE') ? 'Desde BUENOS AIRES' : `Desde ${OriginOverflow}`;
    //--------------------------

    // Prices
    function setPrices(prices, pax) {
      return prices.map((price) => {
        let final = price.netPrice + price.taxes + price.iva;
        if (price.currency === 'ARS') {
          final = final + price.countryTaxes;
        }
        const finalPorPax = Math.round(final / pax);
        return {
          ...price,
          final,
          finalPax: finalPorPax,
          finalPaxFormated: finalPorPax.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.'),
        };
      });
    }

    // setting pax
    let cantPax = 0;
    const urlPasajerosOriginal = new URL(`${window.location}/buscarxpaquetes${oferta.url}`);
    const distribucionCodigo = urlPasajerosOriginal.searchParams.get('h');
    const distribucion = commons.obtenerDistribucion(distribucionCodigo);

    /* eslint-disable */
    distribucion.map((habitacion) => {
      cantPax = cantPax + (
        parseInt(habitacion.adultos) + habitacion.menores.length
      );
    });
    /* eslint-enable */

    // buidl final price per currency
    const currencyDefault = application.currency;
    const listPrices = setPrices(oferta.prices, cantPax);

    // find price with currencyDefault OR fist of the list
    const selectePrice = ((currencyDefault && listPrices.find((price) => price.currency === currencyDefault.code)) || listPrices[0]);
    const host = `https://${isClient ? window.location.hostname : ''}`;
    const departureDate = encodeURIComponent(moment(oferta.departureDate, 'YYYY-MM-DD').format('DD/MM/YYYY'));
    const description = ` Salida: ${departureDate} ${selectePrice.currency} ${selectePrice.finalPaxFormated}`;

    const metaData = {
      // eslint-disable-next-line no-useless-escape
      title: oferta.title.replace('\([^)]*\)/g', '').replace(' ', '%20'),
      img: this.imgValidator(oferta.imageUrl),
      url: encodeURIComponent(`/buscarxpaquetes${oferta.url}`),
      description,
      host,
    };

    function checkCountryTax(destination, priceSelected) {
      if (destination.country_name === 'Argentina') return null;
      let msj = '';

      if (priceSelected.currency === 'USD') {
        msj = 'Impuesto pais no incluido';
      } else if (
        (priceSelected.currency === 'ARS' && priceSelected.countryTaxes === null)
        || (priceSelected.currency === 'ARS' && priceSelected.countryTaxes === 0)
      ) {
        msj = 'No incluye 30% de IMPUESTO PAIS';
      } else {
        msj = 'Incluye 30% de IMPUESTO PAIS';
      }

      return (
        <span data-tip={msj} className='offer-price-info-back'>
          <i className='fa fa-exclamation' />
        </span>
      );

    }
    return (
      <>
        <div className='col-md-4'>
          <div className='panel panel-default contenedor-sombra'>
            <a
              href={`/buscarxpaquetes${this.props.oferta.url}`}
              target='_blank'
              rel='noopener noreferrer'
            >
              <div className='panel-body image-oferta' style={{ backgroundImage: `url('${this.imgValidator(oferta.imageUrl)}')` }}>
                <div className='contenido-degradado'>
                  <div className='col-md-12 col-xs-12 col-lg-12 contentido-superior'>
                    <span className='oferta-nights'>
                      <span>
                        <i className='fa fa-calendar' />
                        {' '}
                        {FormatDate}
                      </span>
&nbsp; - &nbsp;
                      {Nights}
                      {' '}
                      <i className='fa fa-moon-o' />
                    </span>
                    <span className='contenido-flotante-desde' data-toggle='tooltip' title={OriginComplete}>{Origin}</span>
                  </div>
                  <div className='contenido-flotante-label'>
                    {this.props.oferta.offerLabel !== '' && oferta.offerLabel != null && (
                      <>
                        <span className='offer-label label'>
                          {this.props.oferta.offerLabel}
                        </span>
                      </>
                    )}
                  </div>
                  <div className='contenido-flotante-iconos'>
                    <div className='col-md-12'>
                      {this.generarIconosServicios(oferta.services)}
                    </div>
                  </div>
                </div>
              </div>
              <div className='offer-title'>
                <div className='color-dinamico-fondo'>
                  <div className='stg-title'>{titleCleaning}</div>
                </div>
              </div>
            </a>
            <div className='offer-footer-panel'>
              <span className='module offer-price'>
                <span className='offer-currency'>{selectePrice.currency}</span>
                <span className='offer-price color-dinamico'>
                  {selectePrice.finalPaxFormated}
                </span>
                <ReactTooltip data-html={true} />
                {checkCountryTax(oferta.destinationInformation, selectePrice)}
              </span>
              <span className='module offer-share'>
                <ShareWith
                  metaData={metaData}
                  type='facebook'
                />
                <ShareWith
                  metaData={metaData}
                  type='whatsapp'
                />
              </span>
            </div>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = function (state) {
  return {
    application: state.applicationState,
  };
};

export default connect(mapStateToProps, null)(Oferta);
